import { Directive, HostListener } from '@angular/core';
import { NgControl } from '@angular/forms';

@Directive({
  selector: '[appPanValidatior]'
})
export class PanValidatiorDirective {

  constructor(private ngControl: NgControl) { }

  @HostListener('input', ['$event']) onInput(event: any): void {
    const inputValue: string = (this.ngControl.value as string).toUpperCase();
    event.preventDefault();
    this.ngControl.control?.setValue(this.formatPanInput(inputValue), { emitEvent: false })
    // this.ngControl.value  = ;

  }

  private formatPanInput(inputValue: string): string {
    const valueArr = inputValue.split('');
    if (valueArr.length <= 5) {
      const validCharacters = inputValue.match(/[A-Z]/g);
      return validCharacters ? validCharacters.join('') : '';
    } else if (valueArr.length > 5 && valueArr.length <= 9) {
      const numberVal = valueArr.slice(5, 9).join('');
      const validCharacters = numberVal.replace(/[^0-9]/g, '');
      return valueArr.slice(0, 5).join('') + (validCharacters ? validCharacters : '');
    } else if (valueArr.length === 10) {
      const numberVal = valueArr.slice(-1).join('');
      const validCharacters = numberVal.match(/[A-Z]/g);
      return valueArr.slice(0, 9).join('') + (validCharacters ? validCharacters.join('') : '');
    } else if (valueArr.length > 10) {
      return valueArr.slice(0, 10).join('');
    } else {
      return inputValue;
    }


  }

}
